export default "__VITE_ASSET__BpbmZhx5__"